import React from 'react'
import { Text } from 'ui'

// Search and Filter Icons
export const BellIcon: React.FC<{ fill?: string }> = ({ fill = '#272727' }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M6.50248 6.97519C6.78492 4.15083 9.16156 2 12 2C14.8384 2 17.2151 4.15083 17.4975 6.97519L17.7841 9.84133C17.8016 10.0156 17.8103 10.1028 17.8207 10.1885C17.9649 11.3717 18.3717 12.5077 19.0113 13.5135C19.0576 13.5865 19.1062 13.6593 19.2034 13.8051L20.0645 15.0968C20.8508 16.2763 21.244 16.866 21.0715 17.3412C21.0388 17.4311 20.9935 17.5158 20.9368 17.5928C20.6371 18 19.9283 18 18.5108 18H5.48923C4.07168 18 3.36291 18 3.06318 17.5928C3.00651 17.5158 2.96117 17.4311 2.92854 17.3412C2.75601 16.866 3.14916 16.2763 3.93548 15.0968L4.79661 13.8051C4.89378 13.6593 4.94236 13.5865 4.98873 13.5135C5.62832 12.5077 6.03508 11.3717 6.17927 10.1885C6.18972 10.1028 6.19844 10.0156 6.21587 9.84133L6.50248 6.97519Z" fill={fill} />
      <path d="M10.0681 20.6294C10.1821 20.7357 10.4332 20.8297 10.7825 20.8967C11.1318 20.9637 11.5597 21 12 21C12.4403 21 12.8682 20.9637 13.2175 20.8967C13.5668 20.8297 13.8179 20.7357 13.9319 20.6294" stroke={fill} stroke-width="2" stroke-linecap="round" />
    </svg>
  </div>
)

export const ImageUploadIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 6C1.5 4.75736 2.50736 3.75 3.75 3.75H20.25C21.4926 3.75 22.5 4.75736 22.5 6V18C22.5 19.2426 21.4926 20.25 20.25 20.25H3.75C2.50736 20.25 1.5 19.2426 1.5 18V6ZM3 16.0607V18C3 18.4142 3.33579 18.75 3.75 18.75H20.25C20.6642 18.75 21 18.4142 21 18V16.0607L18.3107 13.3713C17.7249 12.7855 16.7751 12.7855 16.1893 13.3713L15.3107 14.25L16.2803 15.2197C16.5732 15.5126 16.5732 15.9874 16.2803 16.2803C15.9874 16.5732 15.5126 16.5732 15.2197 16.2803L10.0607 11.1213C9.47487 10.5355 8.52513 10.5355 7.93934 11.1213L3 16.0607ZM13.125 8.25C13.125 7.62868 13.6287 7.125 14.25 7.125C14.8713 7.125 15.375 7.62868 15.375 8.25C15.375 8.87132 14.8713 9.375 14.25 9.375C13.6287 9.375 13.125 8.87132 13.125 8.25Z" fill="#4F4F4F" />
    </svg>
  )
}

export const SmallRedDot: React.FC = () => (
  <div style={{ position: 'absolute', top: -5, right: 2}}>
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
    <circle cx="3.51602" cy="3.51602" r="3.51602" fill="#FF1D51"/>
  </svg>
  </div>
)

export const SearchIcon: React.FC = () => {
  return React.createElement('svg', {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none"
  }, React.createElement('path', {
    d: "M16.6 18L10.3 11.7C9.8 12.1 9.225 12.4167 8.575 12.65C7.925 12.8833 7.23333 13 6.5 13C4.68333 13 3.14583 12.3708 1.8875 11.1125C0.629167 9.85417 0 8.31667 0 6.5C0 4.68333 0.629167 3.14583 1.8875 1.8875C3.14583 0.629167 4.68333 0 6.5 0C8.31667 0 9.85417 0.629167 11.1125 1.8875C12.3708 3.14583 13 4.68333 13 6.5C13 7.23333 12.8833 7.925 12.65 8.575C12.4167 9.225 12.1 9.8 11.7 10.3L18 16.6L16.6 18ZM6.5 11C7.75 11 8.8125 10.5625 9.6875 9.6875C10.5625 8.8125 11 7.75 11 6.5C11 5.25 10.5625 4.1875 9.6875 3.3125C8.8125 2.4375 7.75 2 6.5 2C5.25 2 4.1875 2.4375 3.3125 3.3125C2.4375 4.1875 2 5.25 2 6.5C2 7.75 2.4375 8.8125 3.3125 9.6875C4.1875 10.5625 5.25 11 6.5 11Z",
    fill: "#B0B0B0"
  }))
}

export const GreenXIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <mask id="mask0_5267_8440" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
        <rect y="0.0996094" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5267_8440)">
        <path d="M2.4 17.0995L1 15.6995L4.6 12.0995L1 8.52451L2.4 7.12451L6 10.7245L9.575 7.12451L10.975 8.52451L7.375 12.0995L10.975 15.6995L9.575 17.0995L6 13.4995L2.4 17.0995Z" fill="#B0B0B0" />
      </g>
    </svg>
  )
}

export const FilterIcon: React.FC<{ isTyping: boolean; onClear: () => void; onClick: () => void; usedAdvancedFilters?: boolean; selectedAdvancedFiltersCategories?: string[] }> = ({ isTyping, onClear, onClick, usedAdvancedFilters, selectedAdvancedFiltersCategories }) => (
  <div style={{
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
    gap: '8px',
    height: '40px',
    minWidth: (isTyping || usedAdvancedFilters) ? '60px' : '40px',
    transition: 'min-width 0.2s ease'
  }} onClick={onClick}>

    {usedAdvancedFilters && (
      <div style={{
        display: 'flex',
        "width": "20px",
        "height": "20px",
        "padding": "10px",
        "flexDirection": "column",
        "justifyContent": "center",
        "alignItems": "center",
        "gap": "10px",
        "borderRadius": "100px",
        "border": "2px solid #FFF",
        "background": "#272727",
        "position": "absolute",
        "right": "0",
        "top": "0",
      }}>
        <Text style={{ fontSize: "12px", color: "white" }} weight="medium">{selectedAdvancedFiltersCategories?.length}</Text>
      </div>
    )}
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none">
      <path d="M7 12V10H11V12H7ZM3 7V5H15V7H3ZM0 2V0H18V2H0Z" fill="#272727" />
    </svg>
    {(isTyping || usedAdvancedFilters) && (
      <>
        <div style={{ width: "1px", height: "24px", background: "#D1D1D1" }}></div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          onClick={(e) => {
            e.stopPropagation()
            onClear()
          }}
          style={{ cursor: 'pointer' }}
        >
          <mask id="mask0_5058_32190" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect y="0" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_5058_32190)">
            <path d="M6.4 18.4L5 17L10.6 11.4L5 5.8L6.4 4.4L12 10L17.6 4.4L19 5.8L13.4 11.4L19 17L17.6 18.4L12 12.8L6.4 18.4Z" fill="#272727" />
          </g>
        </svg>
      </>
    )}
  </div>
)

export const MinusIcon = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
      <mask id="mask0_5063_22756" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="21">
        <rect x="0.501465" y="0.799316" width="19.8794" height="19.8794" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5063_22756)">
        <path d="M5.82056 11.6188V9.95215H15.8206V11.6188H5.82056Z" fill="white" />
      </g>
    </svg>
  </div>
)

export const Vicon = ({ fill }: { fill?: string }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <mask id="mask0_5058_41814" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
          <rect y="0.299805" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5058_41814)">
          <path d="M10.6 16.8998L17.65 9.8498L16.25 8.4498L10.6 14.0998L7.75 11.2498L6.35 12.6498L10.6 16.8998ZM12 22.2998C10.6167 22.2998 9.31667 22.0373 8.1 21.5123C6.88333 20.9873 5.825 20.2748 4.925 19.3748C4.025 18.4748 3.3125 17.4165 2.7875 16.1998C2.2625 14.9831 2 13.6831 2 12.2998C2 10.9165 2.2625 9.61647 2.7875 8.3998C3.3125 7.18314 4.025 6.1248 4.925 5.2248C5.825 4.3248 6.88333 3.6123 8.1 3.0873C9.31667 2.5623 10.6167 2.2998 12 2.2998C13.3833 2.2998 14.6833 2.5623 15.9 3.0873C17.1167 3.6123 18.175 4.3248 19.075 5.2248C19.975 6.1248 20.6875 7.18314 21.2125 8.3998C21.7375 9.61647 22 10.9165 22 12.2998C22 13.6831 21.7375 14.9831 21.2125 16.1998C20.6875 17.4165 19.975 18.4748 19.075 19.3748C18.175 20.2748 17.1167 20.9873 15.9 21.5123C14.6833 22.0373 13.3833 22.2998 12 22.2998Z" fill={fill || "#00A471"} />
        </g>
      </svg>
    </div>
  )
}

export const ThinBackArrow = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_5142_15789" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5142_15789)">
        <path d="M9.10669 20L7.75 18.58L14.0366 12L7.75 5.42L9.10669 4L16.75 12L9.10669 20Z" fill="#4F4F4F" />
      </g>
    </svg>
  )
}

export const DoubbleCopyIcon = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path d="M8.83325 8.57845V5.15647C8.83325 3.78745 8.83325 3.10243 9.09967 2.57954C9.33403 2.11958 9.7077 1.7459 10.1676 1.51155C10.6905 1.24512 11.3755 1.24512 12.7446 1.24512H19.5889C20.9579 1.24512 21.6421 1.24512 22.1649 1.51155C22.6249 1.7459 22.9992 2.11958 23.2336 2.57954C23.5 3.10243 23.5 3.78694 23.5 5.15596V12.0004C23.5 13.3695 23.5 14.054 23.2336 14.5769C22.9992 15.0368 22.6245 15.4113 22.1646 15.6456C21.6422 15.9118 20.9588 15.9118 19.5924 15.9118H16.1665M8.83325 8.57845H5.4113C4.0423 8.57845 3.35729 8.57845 2.8344 8.84488C2.37446 9.07924 2.00078 9.45292 1.76643 9.91287C1.5 10.4358 1.5 11.1208 1.5 12.4898V19.3342C1.5 20.7033 1.5 21.3874 1.76643 21.9103C2.00078 22.3703 2.37446 22.7446 2.8344 22.9789C3.35678 23.2451 4.04096 23.2451 5.40729 23.2451H12.2598C13.6261 23.2451 14.3093 23.2451 14.8317 22.9789C15.2916 22.7446 15.666 22.3699 15.9003 21.9099C16.1665 21.3876 16.1665 20.7041 16.1665 19.3378V15.9118M8.83325 8.57845H12.2557C13.6247 8.57845 14.3088 8.57845 14.8317 8.84488C15.2916 9.07924 15.666 9.45292 15.9003 9.91287C16.1665 10.4353 16.1665 11.1195 16.1665 12.4858L16.1665 15.9118" stroke="#272727" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>
)

export const GlobeIcon = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
      <path d="M10.1032 17.6804C13.633 17.6804 16.5991 15.2668 17.4411 11.9999M10.1032 17.6804C6.57336 17.6804 3.60726 15.2668 2.76524 11.9999M10.1032 17.6804C12.1956 17.6804 13.8918 14.2879 13.8918 10.1031C13.8918 5.91823 12.1956 2.52576 10.1032 2.52576M10.1032 17.6804C8.01077 17.6804 6.31453 14.2879 6.31453 10.1031C6.31453 5.91823 8.01077 2.52576 10.1032 2.52576M10.1032 2.52576C12.9364 2.52576 15.4065 4.08074 16.7064 6.38382M10.1032 2.52576C7.26995 2.52576 4.79991 4.08074 3.49992 6.38382M16.7064 6.38382C14.9356 7.91439 12.6275 8.84018 10.1032 8.84018C7.57886 8.84018 5.27077 7.91439 3.49992 6.38382M16.7064 6.38382C17.3266 7.48252 17.6805 8.75146 17.6805 10.1031C17.6805 10.7581 17.5974 11.3937 17.4411 11.9999M17.4411 11.9999C15.267 13.2053 12.7653 13.8917 10.1032 13.8917C7.44111 13.8917 4.93935 13.2053 2.76524 11.9999M2.76524 11.9999C2.60899 11.3937 2.52588 10.7581 2.52588 10.1031C2.52588 8.75146 2.87976 7.48252 3.49992 6.38382" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>
)

export const GiftIcon = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'absolute', top: '-137px', left: '50%', transform: 'translateX(-50%)' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="122" height="138" viewBox="0 0 122 138" fill="none">
      <g clip-path="url(#clip0_5065_89165)">
        <path d="M85.6835 2.19238L99.3666 7.99615C99.3666 7.99615 94.711 14.8594 88.1916 20.1178C81.6722 25.3763 65.5348 29.1701 65.5348 29.1701H60.8792C60.8792 29.1701 74.2247 22.4549 79.5016 16.6122C84.7785 10.7695 85.6835 2.19238 85.6835 2.19238Z" fill="#BDBACA" />
        <path d="M69.8761 6.39024C76.3955 1.71606 84.9781 1.45898 84.9781 1.45898L99.3668 7.99504C99.3668 7.99504 84.7787 10.4412 78.2593 15.9879C71.7399 21.5346 60.8793 29.169 60.8793 29.169L56.845 28.873C56.845 28.873 63.3644 11.0566 69.8838 6.38245L69.8761 6.39024Z" fill="#F2F5F4" />
        <path d="M36.0824 2.19238L19.27 7.99615C19.27 7.99615 23.9256 14.8594 30.445 20.1178C36.9644 25.3763 53.1019 29.1701 53.1019 29.1701H57.7575C57.7575 29.1701 44.4119 22.4549 39.135 16.6122C33.8581 10.7695 36.0747 2.19238 36.0747 2.19238H36.0824Z" fill="#BDBACA" />
        <path d="M48.768 6.39112C42.2486 1.71695 35.7522 0.400391 35.7522 0.400391L19.2773 7.99592C19.2773 7.99592 33.8655 10.4421 40.3849 15.9888C46.9042 21.5354 57.7648 29.1699 57.7648 29.1699L61.7992 28.8739C61.7992 28.8739 55.2798 11.0575 48.7604 6.38333L48.768 6.39112Z" fill="#F2F5F4" />
        <path d="M88.5818 137.399H117.206L117.206 35.9777H88.5818L88.5818 137.399Z" fill="#ED3449" />
        <path d="M89.51 51.0293H117.329V45.7942H89.51V51.0293Z" fill="#CD1C38" />
        <path d="M89.5094 35.9785H4.67285V137.4H89.5094V35.9785Z" fill="#D61E3B" />
        <path d="M89.5094 42.5225H4.67285V51.0295H89.5094V42.5225Z" fill="#BC1833" />
        <path d="M90.7599 47.1025L121.501 47.1025V26.1622L90.7599 26.1622V47.1025Z" fill="#ED3449" />
        <path d="M91.6189 26.1631H0.500732V47.1034H91.6189V26.1631Z" fill="#D61E3B" />
        <path d="M55.4394 24.8545H38.7498V137.401H55.4394V24.8545Z" fill="#C0CCD9" />
        <path d="M108.285 24.8545H102.026V137.401H108.285V24.8545Z" fill="#F2F5F4" />
      </g>
      <defs>
        <clipPath id="clip0_5065_89165">
          <rect width="121" height="137" fill="white" transform="translate(0.5 0.400391)" />
        </clipPath>
      </defs>
    </svg>
  </div>
)

export const NotificationsGiftIcon = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M11 15V21H8C7.05719 21 6.58586 20.9999 6.29297 20.707C6.00008 20.4141 6 19.9428 6 19V15H11ZM18 19C18 19.9428 17.9999 20.4141 17.707 20.707C17.4141 20.9999 16.9428 21 16 21H13V15H18V19ZM19 8C19.9428 8 20.4141 8.00008 20.707 8.29297C20.9999 8.58586 21 9.05719 21 10V11C21 11.9428 20.9999 12.4141 20.707 12.707C20.4141 12.9999 19.9428 13 19 13H13V8H19ZM11 13H5C4.05719 13 3.58586 12.9999 3.29297 12.707C3.00008 12.4141 3 11.9428 3 11V10C3 9.05719 3.00008 8.58586 3.29297 8.29297C3.58586 8.00008 4.05719 8 5 8H11V13Z" fill="#EAB308" />
      <path d="M19 4.63246V4.45035C19 3.24487 17.819 2.39366 16.6754 2.77487C15.2448 3.25174 13.9449 4.05514 12.8786 5.12144L12 6V7H15.6754C15.8904 7 16.104 6.96534 16.3079 6.89737L17.7026 6.43246C18.4774 6.1742 19 5.44914 19 4.63246Z" fill="#EAB308" />
      <path d="M5 4.63246V4.45035C5 3.24487 6.18099 2.39366 7.3246 2.77487C8.75521 3.25174 10.0551 4.05514 11.1214 5.12144L12 6V7H8.32456C8.10959 7 7.89603 6.96534 7.6921 6.89737L6.29737 6.43246C5.52259 6.1742 5 5.44914 5 4.63246Z" fill="#EAB308" />
    </svg>
  </div>
)

export const WhatsappIcon: React.FC = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5859 5.70611C17.7061 3.8329 15.2059 2.80078 12.542 2.7998C7.05287 2.7998 2.58549 7.24527 2.58357 12.7095C2.58263 14.4563 3.04149 16.1613 3.9129 17.6639L2.5 22.7998L7.77911 21.4217C9.2335 22.2115 10.8713 22.6273 12.5377 22.6278H12.542C18.0302 22.6278 22.4981 18.1819 22.5 12.7176C22.5009 10.0694 21.4662 7.57982 19.5859 5.70657V5.70611ZM12.542 20.9542H12.5387C11.0537 20.9537 9.59688 20.5564 8.32582 19.8061L8.02358 19.6275L4.89079 20.4452L5.72687 17.4054L5.53012 17.0937C4.70169 15.7822 4.26385 14.2662 4.26479 12.71C4.26671 8.16855 7.97966 4.47342 12.5454 4.47342C14.7561 4.4744 16.8342 5.33214 18.3969 6.88934C19.9598 8.44607 20.8197 10.5161 20.8188 12.7167C20.8168 17.2586 17.104 20.9537 12.542 20.9537V20.9542ZM17.0819 14.7852C16.8332 14.6612 15.6099 14.0624 15.3816 13.9797C15.1534 13.897 14.9878 13.8557 14.822 14.1037C14.6563 14.3518 14.1794 14.9097 14.0342 15.0745C13.889 15.2399 13.7439 15.2604 13.4951 15.1363C13.2463 15.0123 12.4446 14.751 11.4939 13.9075C10.7543 13.2507 10.2548 12.4401 10.1097 12.192C9.96456 11.944 10.0944 11.81 10.2186 11.6869C10.3303 11.5757 10.4673 11.3975 10.592 11.253C10.7166 11.1086 10.7577 11.005 10.8407 10.8401C10.9239 10.6747 10.8823 10.5303 10.8203 10.4062C10.7581 10.2822 10.2606 9.06333 10.0529 8.56772C9.85088 8.08495 9.64562 8.15052 9.49331 8.14244C9.34809 8.13529 9.18244 8.13389 9.01629 8.13389C8.85013 8.13389 8.5808 8.19563 8.35256 8.44373C8.12432 8.69171 7.48162 9.29098 7.48162 10.5093C7.48162 11.7278 8.37311 12.9058 8.49774 13.0712C8.62233 13.2365 10.2524 15.7375 12.7483 16.8105C13.3418 17.0656 13.8054 17.2182 14.1669 17.3322C14.7628 17.5209 15.3052 17.4943 15.734 17.4306C16.212 17.3593 17.2061 16.8314 17.4134 16.253C17.6205 15.6747 17.6205 15.1786 17.5585 15.0755C17.4965 14.9724 17.3303 14.9101 17.0815 14.7861L17.0819 14.7852Z" fill="#16AA40" />
    </svg>
  </div>
)

export const ShareIcon: React.FC<{ fill: string }> = ({ fill }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <path d="M10.4435 12.7734L12.1976 20.6668C12.2971 21.1145 12.8923 21.2111 13.1282 20.8179L21.1479 7.45175C21.3509 7.11347 21.1072 6.68311 20.7127 6.68311H4.71011C4.23892 6.68311 4.02206 7.26933 4.37981 7.57597L10.4435 12.7734ZM10.4435 12.7734L20.594 7.19063" stroke={fill} stroke-width="2.03011" />
    </svg>
  </div>
)

export const BlackPointUpArrowIcon: React.FC = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
      <path d="M5.13397 0.599611C5.51887 -0.0670558 6.48113 -0.0670572 6.86603 0.599609L11.2469 8.1875C11.6318 8.85417 11.1507 9.6875 10.3809 9.6875H1.61913C0.849331 9.6875 0.368204 8.85417 0.753104 8.1875L5.13397 0.599611Z" fill="#272727" />
    </svg>
  </div>
)

export const PlusIcon: React.FC = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_5267_1408" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5267_1408)">
        <path d="M11 21V13H3V11H11V3H13V11H21V13H13V21H11Z" fill="white" />
      </g>
    </svg>
  </div>
)

// Coupons Icons
export const PersonIcon: React.FC<{ fill: string }> = ({ fill }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path d="M12.5 11.5C11.1938 11.5 10.0755 11.0349 9.14531 10.1047C8.2151 9.17448 7.75 8.05625 7.75 6.75C7.75 5.44375 8.2151 4.32552 9.14531 3.39531C10.0755 2.4651 11.1938 2 12.5 2C13.8062 2 14.9245 2.4651 15.8547 3.39531C16.7849 4.32552 17.25 5.44375 17.25 6.75C17.25 8.05625 16.7849 9.17448 15.8547 10.1047C14.9245 11.0349 13.8062 11.5 12.5 11.5ZM3 21V17.675C3 17.0021 3.17318 16.3836 3.51953 15.8195C3.86589 15.2555 4.32604 14.825 4.9 14.5281C6.12708 13.9146 7.37396 13.4544 8.64062 13.1477C9.90729 12.8409 11.1938 12.6875 12.5 12.6875C13.8062 12.6875 15.0927 12.8409 16.3594 13.1477C17.626 13.4544 18.8729 13.9146 20.1 14.5281C20.674 14.825 21.1341 15.2555 21.4805 15.8195C21.8268 16.3836 22 17.0021 22 17.675V21H3Z" fill={fill} />
      </svg>
    </div>
  )
}

export const HeartIcon: React.FC<{ fill: string }> = ({ fill }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <path d="M12.0836 20.2979L12.0771 20.2945L12.055 20.2829C12.0361 20.2729 12.0092 20.2586 11.9749 20.2401C11.9062 20.203 11.8074 20.1488 11.6829 20.0784C11.434 19.9375 11.0816 19.731 10.66 19.4647C9.8187 18.9333 8.69279 18.1577 7.56249 17.1836C5.35339 15.2798 2.90002 12.4227 2.90002 9.00001C2.90002 6.01767 5.31769 3.60001 8.30002 3.60001C9.99731 3.60001 11.5105 4.38286 12.5 5.6059C13.4895 4.38286 15.0027 3.60001 16.7 3.60001C19.6824 3.60001 22.1 6.01767 22.1 9.00001C22.1 12.4227 19.6467 15.2798 17.4376 17.1836C16.3073 18.1577 15.1813 18.9333 14.3401 19.4647C13.9185 19.731 13.5661 19.9375 13.3172 20.0784C13.1927 20.1488 13.0939 20.203 13.0252 20.2401C12.9908 20.2586 12.9639 20.2729 12.9451 20.2829L12.9229 20.2945L12.9164 20.2979L12.9144 20.2989C12.656 20.436 12.344 20.436 12.0864 20.2993L12.0836 20.2979Z" fill={fill} />
      </svg>
    </div>
  )
}

export const CouponIcon: React.FC<{ fill: string; width?: number | string; height?: number | string }> = ({ fill, width = 25, height = 24 }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 25 24" fill={fill}>
        <path d="M22.25 9.75C22.664 9.75 23 9.414 23 9V6.75C23 5.5095 21.9905 4.5 20.75 4.5H16.25V6.75C16.25 7.164 15.914 7.5 15.5 7.5C15.086 7.5 14.75 7.164 14.75 6.75V4.5H4.25C3.0095 4.5 2 5.5095 2 6.75V9C2 9.414 2.336 9.75 2.75 9.75C3.9905 9.75 5 10.7595 5 12C5 13.2405 3.9905 14.25 2.75 14.25C2.336 14.25 2 14.586 2 15V17.25C2 18.4905 3.0095 19.5 4.25 19.5H14.75V17.25C14.75 16.836 15.086 16.5 15.5 16.5C15.914 16.5 16.25 16.836 16.25 17.25V19.5H20.75C21.9905 19.5 23 18.4905 23 17.25V15C23 14.586 22.664 14.25 22.25 14.25C21.0095 14.25 20 13.2405 20 12C20 10.7595 21.0095 9.75 22.25 9.75ZM16.25 14.25C16.25 14.664 15.914 15 15.5 15C15.086 15 14.75 14.664 14.75 14.25V13.5C14.75 13.086 15.086 12.75 15.5 12.75C15.914 12.75 16.25 13.086 16.25 13.5V14.25ZM16.25 10.5C16.25 10.914 15.914 11.25 15.5 11.25C15.086 11.25 14.75 10.914 14.75 10.5V9.75C14.75 9.336 15.086 9 15.5 9C15.914 9 16.25 9.336 16.25 9.75V10.5Z" fill={fill} />
      </svg>
    </div>
  )
}

export const CalendarIcon: React.FC<{ fill?: string }> = ({ fill }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill={fill ? fill : 'none'}>
        <path d="M4.5 8.90039H20.5M4.5 8.90039V17.7006C4.5 18.8207 4.5 19.3805 4.71799 19.8083C4.90973 20.1846 5.21547 20.4909 5.5918 20.6826C6.0192 20.9004 6.57899 20.9004 7.69691 20.9004H17.3031C18.421 20.9004 18.98 20.9004 19.4074 20.6826C19.7837 20.4909 20.0905 20.1846 20.2822 19.8083C20.5 19.3809 20.5 18.8219 20.5 17.704V8.90039M4.5 8.90039V8.10059C4.5 6.98048 4.5 6.42001 4.71799 5.99219C4.90973 5.61586 5.21547 5.31012 5.5918 5.11838C6.01962 4.90039 6.58009 4.90039 7.7002 4.90039H8.5M20.5 8.90039V8.0973C20.5 6.97938 20.5 6.41959 20.2822 5.99219C20.0905 5.61586 19.7837 5.31012 19.4074 5.11838C18.9796 4.90039 18.4203 4.90039 17.3002 4.90039H16.5M8.5 4.90039H16.5M8.5 4.90039V2.90039M16.5 4.90039V2.90039M15.5 12.9004L11.5 16.9004L9.5 14.9004" stroke="#B0B0B0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  )
}

export const BackArrowIcon: React.FC<{ fill: string }> = ({ fill }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill={fill}>
        <mask id="mask0_5063_30733" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
          <rect x="0.739319" y="0.5" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5063_30733)">
          <path d="M8.76432 22.5L6.98932 20.725L15.2143 12.5L6.98932 4.275L8.76432 2.5L18.7643 12.5L8.76432 22.5Z" fill={fill} />
        </g>
      </svg>
    </div>
  )
}

export const ForwardArrowIcon: React.FC<{ fill: string }> = ({ fill }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill={fill}>
        <mask id="mask0_5064_59131" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
          <rect x="24" y="24.6016" width="24" height="24" transform="rotate(-180 24 24.6016)" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5064_59131)">
          <path d="M15.975 2.60156L17.75 4.37656L9.525 12.6016L17.75 20.8266L15.975 22.6016L5.975 12.6016L15.975 2.60156Z" fill={fill} />
        </g>
      </svg>
    </div>
  )
}

// CouponCard Icons
export const LoveIcon: React.FC<{ liked: boolean, onClick: () => void }> = ({ liked, onClick }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        {liked ? (
          <>
            <mask id="mask0_5267_14040" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
              <rect y="0.700195" width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_5267_14040)">
              <path d="M12 21.2002L10.695 19.9958C9.18 18.5908 7.9275 17.3787 6.9375 16.3596C5.9475 15.3405 5.16 14.4257 4.575 13.615C3.99 12.8044 3.58125 12.0594 3.34875 11.38C3.11625 10.7006 3 10.0058 3 9.29556C3 7.84416 3.4725 6.63208 4.4175 5.65932C5.3625 4.68657 6.54 4.2002 7.95 4.2002C8.73 4.2002 9.4725 4.37004 10.1775 4.70973C10.8825 5.04942 11.49 5.52808 12 6.1457C12.51 5.52808 13.1175 5.04942 13.8225 4.70973C14.5275 4.37004 15.27 4.2002 16.05 4.2002C17.46 4.2002 18.6375 4.68657 19.5825 5.65932C20.5275 6.63208 21 7.84416 21 9.29556C21 10.0058 20.8838 10.7006 20.6513 11.38C20.4188 12.0594 20.01 12.8044 19.425 13.615C18.84 14.4257 18.0525 15.3405 17.0625 16.3596C16.0725 17.3787 14.82 18.5908 13.305 19.9958L12 21.2002Z" fill="#FF1D51" />
            </g>
          </>
        ) : (
          <>
            <mask id="mask0_5267_1077" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
              <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_5267_1077)">
              <path d="M16.0498 4.25006C17.2661 4.25006 18.2473 4.66047 19.0449 5.48151C19.8437 6.3038 20.25 7.32443 20.25 8.59576C20.25 9.22225 20.1473 9.83472 19.9414 10.4366C19.7402 11.0245 19.3737 11.7034 18.8164 12.4756C18.2596 13.2473 17.4987 14.1339 16.5244 15.1368C15.5468 16.1431 14.3046 17.3449 12.7959 18.7442L12 19.4786L11.2031 18.7442C9.69464 17.3451 8.45307 16.143 7.47559 15.1368C6.50135 14.1339 5.74045 13.2473 5.18359 12.4756C4.6263 11.7034 4.25981 11.0245 4.05859 10.4366C3.85266 9.83472 3.75004 9.22225 3.75 8.59576C3.75 7.32443 4.15626 6.3038 4.95508 5.48151C5.75269 4.66047 6.73386 4.25006 7.9502 4.25006C8.61695 4.25009 9.24788 4.39476 9.85156 4.68561C10.4566 4.97716 10.9792 5.3868 11.4219 5.92291L12 6.62311L12.5781 5.92291C13.0208 5.3868 13.5434 4.97716 14.1484 4.68561C14.7521 4.39476 15.3831 4.25009 16.0498 4.25006Z" stroke="#272727" strokeWidth="1.5" />
            </g>
          </>
        )}
      </svg>
    </div>
  )
}

export const XIcon: React.FC = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <mask id="mask0_5058_34590" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
          <rect y="0.0996094" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5058_34590)">
          <path d="M18 18.0996L12 12.0996M12 12.0996L6 6.09961M12 12.0996L18 6.09961M12 12.0996L6 18.0996" stroke="#272727" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </g>
      </svg>
    </div>
  )
}


export const ReplayIcon: React.FC = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
        <mask id="mask0_5058_34597" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="23" height="23">
          <rect x="0.479248" y="0.0791016" width="22.0415" height="22.0415" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5058_34597)">
          <path d="M11.4999 20.2834C10.3519 20.2834 9.27666 20.0653 8.27407 19.629C7.27149 19.1928 6.39901 18.6035 5.65664 17.8611C4.91427 17.1187 4.32497 16.2463 3.88873 15.2437C3.45249 14.2411 3.23438 13.1658 3.23438 12.0178H5.07117C5.07117 13.8087 5.69491 15.3279 6.9424 16.5754C8.18989 17.8228 9.70907 18.4466 11.4999 18.4466C13.2908 18.4466 14.81 17.8228 16.0575 16.5754C17.305 15.3279 17.9287 13.8087 17.9287 12.0178C17.9287 10.2269 17.305 8.70777 16.0575 7.46028C14.81 6.21279 13.2908 5.58905 11.4999 5.58905H11.3622L12.7857 7.01256L11.4999 8.34424L7.82635 4.67065L11.4999 0.99707L12.7857 2.32874L11.3622 3.75226H11.4999C12.6479 3.75226 13.7232 3.97038 14.7258 4.40662C15.7284 4.84285 16.6009 5.43216 17.3432 6.17453C18.0856 6.9169 18.6749 7.78937 19.1111 8.79196C19.5474 9.79454 19.7655 10.8698 19.7655 12.0178C19.7655 13.1658 19.5474 14.2411 19.1111 15.2437C18.6749 16.2463 18.0856 17.1187 17.3432 17.8611C16.6009 18.6035 15.7284 19.1928 14.7258 19.629C13.7232 20.0653 12.6479 20.2834 11.4999 20.2834Z" fill="#272727" />
        </g>
      </svg>
    </div>
  )
}

export const CopyIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 2C6.9 2 6 2.9 6 4v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H8zm0 2h8v8H8V4zm-2 4c0-1.1.9-2 2-2h2v2H8v2H6V8zm8 8c0 1.1-.9 2-2 2H8v-2h8v-2h2v2z" fill="#272727" />
  </svg>
)

export type GradientName = 'gold' | 'red' | 'blue' | 'green' | 'yellow' | 'pink';

const gradients: Record<GradientName, { offset?: string; stopColor: string }[]> = {
  gold: [
    { stopColor: '#EDD06D' },
    { offset: '0.35', stopColor: '#DFB858' },
    { offset: '1', stopColor: '#C2822A' },
  ],
  red: [
    { stopColor: '#FF5C5C' },
    { offset: '0.3', stopColor: '#F34444' },
    { offset: '0.93', stopColor: '#D60606' },
    { offset: '1', stopColor: '#D30000' },
  ],
  blue: [
    { stopColor: '#4D8EFF' },
    { offset: '0.43', stopColor: '#3E76FF' },
    { offset: '1', stopColor: '#2850FF' },
  ],
  green: [
    { stopColor: '#00EE98' },
    { offset: '0.28', stopColor: '#00D685' },
    { offset: '0.87', stopColor: '#009854' },
    { offset: '1', stopColor: '#008A49' },
  ],
  yellow: [
    { stopColor: '#FC9512' },
    { offset: '0.68', stopColor: '#FED319' },
    { offset: '1', stopColor: '#FFEB1C' },
  ],
  pink: [
    { stopColor: '#FF3EB9' },
    { offset: '0.04', stopColor: '#FF43BB' },
    { offset: '0.7', stopColor: '#FF97E2' },
    { offset: '1', stopColor: '#FFB9F2' },
  ],
};

interface ConfettiIconProps {
  width: string;
  height: string;
  pathData: string;
  gradientName: GradientName;
  gradientCoordinates: {
    x1: string;
    y1: string;
    x2: string;
    y2: string;
  };
  style?: React.CSSProperties;
}

export const ArrowLeftIcon: React.FC = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <mask id="mask0_5063_57353" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
          <rect y="0.601562" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5063_57353)">
          <path d="M10 18.6016L4 12.6016L10 6.60156L11.4 8.05156L7.85 11.6016H20V13.6016H7.85L11.4 17.1516L10 18.6016Z" fill="#272727" />
        </g>
      </svg>
    </div>
  )
}

export const DownloadIcon: React.FC = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <mask id="mask0_5063_57390" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="25">
          <rect y="0.601562" width="24" height="24" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5063_57390)">
          <path d="M12 16.6016L7 11.6016L8.4 10.1516L11 12.7516V4.60156H13V12.7516L15.6 10.1516L17 11.6016L12 16.6016ZM6 20.6016C5.45 20.6016 4.97917 20.4057 4.5875 20.0141C4.19583 19.6224 4 19.1516 4 18.6016V15.6016H6V18.6016H18V15.6016H20V18.6016C20 19.1516 19.8042 19.6224 19.4125 20.0141C19.0208 20.4057 18.55 20.6016 18 20.6016H6Z" fill="#B0B0B0" />
        </g>
      </svg>
    </div>
  )
}

export const FileIcon = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#4F87F8', width: '23.5px', height: '23.5px', borderRadius: '100%' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M8.95302 16.0742H13.8423M8.95302 13.6296H13.8423M12.2128 4.66673C12.135 4.66602 12.0474 4.66602 11.9474 4.66602H8.30128C7.38854 4.66602 6.93183 4.66602 6.58321 4.84365C6.27655 4.9999 6.02742 5.24903 5.87117 5.55569C5.69353 5.90431 5.69353 6.36102 5.69353 7.27376V16.7263C5.69353 17.639 5.69353 18.0952 5.87117 18.4438C6.02742 18.7504 6.27655 19 6.58321 19.1562C6.93149 19.3337 7.38766 19.3337 8.29863 19.3337L14.4967 19.3337C15.4076 19.3337 15.8631 19.3337 16.2114 19.1562C16.5181 19 16.768 18.7504 16.9243 18.4438C17.1017 18.0955 17.1017 17.64 17.1017 16.729V9.82064C17.1017 9.72068 17.1017 9.63309 17.1009 9.55525M12.2128 4.66673C12.4454 4.66885 12.592 4.67748 12.7325 4.71122C12.8988 4.75114 13.0582 4.81698 13.204 4.90634C13.3685 5.00709 13.5096 5.14827 13.7913 5.42996L16.3382 7.97683C16.6201 8.25869 16.7602 8.39924 16.861 8.5637C16.9503 8.70952 17.0165 8.86852 17.0564 9.03481C17.0901 9.17534 17.0988 9.32264 17.1009 9.55525M12.2128 4.66673L12.2125 6.94783C12.2125 7.86057 12.2125 8.31676 12.3901 8.66539C12.5464 8.97204 12.7955 9.22154 13.1022 9.37779C13.4505 9.55525 13.9066 9.55525 14.8176 9.55525H17.1009" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>
  )
}

export const ConfettiIcon: React.FC<ConfettiIconProps> = ({
  width,
  height,
  pathData,
  gradientName,
  gradientCoordinates,
  style,
}) => {
  const gradientId = React.useMemo(() => `confetti-gradient-${Math.random().toString(36).substring(2, 9)}`, []);
  const gradientStops = gradients[gradientName];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
    >
      <path d={pathData} fill={`url(#${gradientId})`} />
      <defs>
        <linearGradient
          id={gradientId}
          x1={gradientCoordinates.x1}
          y1={gradientCoordinates.y1}
          x2={gradientCoordinates.x2}
          y2={gradientCoordinates.y2}
          gradientUnits="userSpaceOnUse"
        >
          {gradientStops.map((stop, index) => (
            <stop key={index} {...stop} />
          ))}
        </linearGradient>
      </defs>
    </svg>
  );
};

export const ImagesUploadIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="23" stroke="#D1D1D1" strokeWidth="2" />
    <path d="M24 14V34M14 24H34" stroke="#D1D1D1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const EmeptyCalendarIcon = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z" stroke="#B0B0B0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 2V6" stroke="#B0B0B0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 2V6" stroke="#B0B0B0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 10H21" stroke="#B0B0B0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>
)

export const CuponsFileUploadIcon = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#4F87F8', height: '23.5px', width: '23.5px', borderRadius: '100%' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M8.95302 16.0742H13.8423M8.95302 13.6296H13.8423M12.2128 4.66673C12.135 4.66602 12.0474 4.66602 11.9474 4.66602H8.30128C7.38854 4.66602 6.93183 4.66602 6.58321 4.84365C6.27655 4.9999 6.02742 5.24903 5.87117 5.55569C5.69353 5.90431 5.69353 6.36102 5.69353 7.27376V16.7263C5.69353 17.639 5.69353 18.0952 5.87117 18.4438C6.02742 18.7504 6.27655 19 6.58321 19.1562C6.93149 19.3337 7.38766 19.3337 8.29863 19.3337L14.4967 19.3337C15.4076 19.3337 15.8631 19.3337 16.2114 19.1562C16.5181 19 16.768 18.7504 16.9243 18.4438C17.1017 18.0955 17.1017 17.64 17.1017 16.729V9.82064C17.1017 9.72068 17.1017 9.63309 17.1009 9.55525M12.2128 4.66673C12.4454 4.66885 12.592 4.67748 12.7325 4.71122C12.8988 4.75114 13.0582 4.81698 13.204 4.90634C13.3685 5.00709 13.5096 5.14827 13.7913 5.42996L16.3382 7.97683C16.6201 8.25869 16.7602 8.39924 16.861 8.5637C16.9503 8.70952 17.0165 8.86852 17.0564 9.03481C17.0901 9.17534 17.0988 9.32264 17.1009 9.55525M12.2128 4.66673L12.2125 6.94783C12.2125 7.86057 12.2125 8.31676 12.3901 8.66539C12.5464 8.97204 12.7955 9.22154 13.1022 9.37779C13.4505 9.55525 13.9066 9.55525 14.8176 9.55525H17.1009" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>
)

export const LocationIcon = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11 22C4.92583 22 0 17.0742 0 11C0 4.92583 4.92583 0 11 0C17.0742 0 22 4.92583 22 11C22 17.0742 17.0742 22 11 22ZM11 3.84515C14.0091 3.84515 16.4485 6.28446 16.4485 9.29361C16.4485 12.3027 11 18.1548 11 18.1548C11 18.1548 5.55154 12.3027 5.55154 9.29361C5.55154 6.28446 7.99085 3.84515 11 3.84515ZM11 7.12887C12.1409 7.12887 13.0661 8.05408 13.0661 9.19505C13.0661 10.3359 12.1409 11.2611 11 11.2611C9.85912 11.2611 8.93391 10.3359 8.93391 9.19505C8.93391 8.05408 9.85912 7.12887 11 7.12887Z" fill="#4F87F8" />
    </svg>
  </div>
)

export const CalendarClockIcon = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
      <path d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V8.675C18 8.95833 17.9042 9.19583 17.7125 9.3875C17.5208 9.57917 17.2833 9.675 17 9.675C16.7167 9.675 16.4792 9.57917 16.2875 9.3875C16.0958 9.19583 16 8.95833 16 8.675V8H2V18H7.8C8.08333 18 8.32083 18.0958 8.5125 18.2875C8.70417 18.4792 8.8 18.7167 8.8 19C8.8 19.2833 8.70417 19.5208 8.5125 19.7125C8.32083 19.9042 8.08333 20 7.8 20H2ZM15 21C13.6167 21 12.4375 20.5125 11.4625 19.5375C10.4875 18.5625 10 17.3833 10 16C10 14.6167 10.4875 13.4375 11.4625 12.4625C12.4375 11.4875 13.6167 11 15 11C16.3833 11 17.5625 11.4875 18.5375 12.4625C19.5125 13.4375 20 14.6167 20 16C20 17.3833 19.5125 18.5625 18.5375 19.5375C17.5625 20.5125 16.3833 21 15 21ZM16.675 18.375L17.375 17.675L15.5 15.8V13H14.5V16.2L16.675 18.375Z" fill="#4F87F8" />
    </svg>
  </div>
)

export const EditIcon = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask id="mask0_5098_14784" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5098_14784)">
        <path d="M3 21V16.75L16.2 3.575C16.4 3.39167 16.6208 3.25 16.8625 3.15C17.1042 3.05 17.3583 3 17.625 3C17.8917 3 18.15 3.05 18.4 3.15C18.65 3.25 18.8667 3.4 19.05 3.6L20.425 5C20.625 5.18333 20.7708 5.4 20.8625 5.65C20.9542 5.9 21 6.15 21 6.4C21 6.66667 20.9542 6.92083 20.8625 7.1625C20.7708 7.40417 20.625 7.625 20.425 7.825L7.25 21H3ZM17.6 7.8L19 6.4L17.6 5L16.2 6.4L17.6 7.8Z" fill="#007EFF" />
      </g>
    </svg>
  </div>
)

export const InfoIcon = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="#007EFF" strokeWidth="2" />
      <path d="M12 16V12" stroke="#007EFF" strokeWidth="2" strokeLinecap="round" />
      <circle cx="12" cy="8" r="1" fill="#007EFF" />
    </svg>
  </div>
)
